import React from 'react';
import {
  Box,
  Typography,
  Grid
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  AttachMoney as MoneyIcon,
  LocalMall as LocalMallIcon,
  Inventory as InventoryIcon,
  Factory as FactoryIcon,
  LocalShipping as ShippingIcon,
  Settings as SettingsIcon
} from '@mui/icons-material';

const FeaturesGrid = () => {
  const features = [
    {
      icon: <DashboardIcon sx={{ fontSize: 40, color: '#3498db' }} />,
      title: 'Operations',
      description: 'Dashboard, tasks, calendar, scheduling'
    },
    {
      icon: <PeopleIcon sx={{ fontSize: 40, color: '#e74c3c' }} />,
      title: 'HR',
      description: 'Employee profiles, departments, tracking'
    },
    {
      icon: <MoneyIcon sx={{ fontSize: 40, color: '#27ae60' }} />,
      title: 'Finance',
      description: 'Sales, customers, invoicing, pricing'
    },
    {
      icon: <LocalMallIcon sx={{ fontSize: 40, color: '#f39c12' }} />,
      title: 'Products',
      description: 'Catalog, brands, formulations, testing'
    },
    {
      icon: <InventoryIcon sx={{ fontSize: 40, color: '#9b59b6' }} />,
      title: 'Inventory',
      description: 'Materials, packaging, finished goods'
    },
    {
      icon: <FactoryIcon sx={{ fontSize: 40, color: '#34495e' }} />,
      title: 'Manufacturing',
      description: 'Batch production, line production'
    },
    {
      icon: <ShippingIcon sx={{ fontSize: 40, color: '#16a085' }} />,
      title: 'Supply Chain',
      description: 'Locations, suppliers, templates'
    },
    {
      icon: <SettingsIcon sx={{ fontSize: 40, color: '#95a5a6' }} />,
      title: 'Administration',
      description: 'Settings, users, permissions'
    }
  ];

  return (
    <Box sx={{ py: { xs: 6, md: 10 }, mt: { xs: 4, md: 8 }, backgroundColor: '#ffffff' }}>
      <Box sx={{ maxWidth: '1000px', mx: 'auto', px: { xs: 2, sm: 3 } }}>
        <Grid container spacing={{ xs: 2, sm: 2.5, md: 3 }} justifyContent="center">
          {features.map((feature, index) => (
            <Grid item xs={6} sm={4} md={3} key={index}>
              <Box
                sx={{
                  textAlign: 'center',
                  p: { xs: 2, sm: 3, md: 4 },
                  backgroundColor: '#ffffff',
                  borderRadius: { xs: 2, md: 3 },
                  border: '1px solid #e2e8f0',
                  height: '100%',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    transform: 'translateY(-3px)',
                    boxShadow: '0 8px 25px rgba(0,0,0,0.08)',
                    borderColor: '#cbd5e0'
                  }
                }}
              >
                <Box sx={{ mb: { xs: 1.5, md: 2 } }}>
                  {React.cloneElement(feature.icon, { sx: { fontSize: { xs: 32, sm: 36, md: 40 }, color: feature.icon.props.sx.color } })}
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 500,
                    color: '#2d3748',
                    mb: { xs: 1, md: 1.5 },
                    fontSize: { xs: '0.95rem', sm: '1rem', md: '1.1rem' }
                  }}
                >
                  {feature.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: '#718096',
                    fontSize: { xs: '0.8rem', sm: '0.85rem', md: '0.9rem' },
                    lineHeight: 1.5,
                    display: { xs: 'none', sm: 'block' }
                  }}
                >
                  {feature.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default FeaturesGrid;
